import { ExpoRoot, type RequireContext } from 'expo-router';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { AppNavigation } from './navigation/AppNavigation';

// ─────────────────────────────────────────────────────────────────────────────

export const AppRouter = () => {
  const isExpoRouterEnabled = useFeatureFlag('CELS-4877-order-expo-router-enabled'); // prettier-ignore

  return isExpoRouterEnabled ? (
    <ExpoRoot context={expoRouterContext} />
  ) : (
    <AppNavigation />
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

// Expo Router file-based routing context.
const expoRouterContext = (require as MetroRequire).context('./app');

// ─── Types ───────────────────────────────────────────────────────────────────

// NOTE: Metro provides `require.context`; `NodeJS.Require` type doesn't include it.
type MetroRequire = NodeJS.Require & {
  context: (path: string) => RequireContext;
};
